import React from "react";
import { Link } from "react-router-dom";
import { Button, EmptyState } from "../components/ui";
import { NotFoundArt } from "../assets/illustrations";

export default function NotFound() {
  return <EmptyState art={NotFoundArt} title="ไม่พบหน้านี้" action={<Link to="/"><Button variant="primary">กลับหน้าแรก</Button></Link>} />;
}
